import { ConcreteEncodable } from "./ConcreteEncodable";

import { PauseLifeCycleEventImplEncoder } from "../../encoder/PauseLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { PauseLifeCycleEvent } from "../PauseLifeCycleEvent";

export class PauseLifeCycleEventImpl extends ConcreteEncodable implements PauseLifeCycleEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.PauseLifeCycleEventImpl";

  /*FID=1*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=2*/
  public id: string;
  /*FID=3*/
  public orders: Array<CubiqTS.PauseOrderData> | null = null;
  /*FID=4*/
  public unsolicited: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PauseLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(PauseLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PauseLifeCycleEventImpl[" +
      "eventTypeId=" +
      this.eventTypeId +
      "id=" +
      this.id +
      "orders=" +
      this.orders +
      "unsolicited=" +
      this.unsolicited +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
